<div class="container">
    <button class="container-test" (click)="redirectUser()">
        <div>
            <svg-icon src="assets/images/icon-return.svg"></svg-icon>
            <div class="text">
                {{label}}
            </div>
        </div>
    </button>
</div>